import React, { useState, useEffect } from 'react';
import { debounce } from 'lodash';
import Utils from 'commons/utils';
import ApiServices from 'services';
import { Table, ModalFormDetail } from 'components';
import { Box, IconButton } from '@mui/material';
import { BsPlusCircle, BsArrowDownCircle } from 'react-icons/bs';
import VisibilityIcon from '@mui/icons-material/Visibility';
import BorderColor from '@mui/icons-material/BorderColor';

import { ContainerHeader, BtnCreateContract, ButtonExport } from './styles';

import { DetailContract } from './detail-contract';
import { CreateForm } from './create-form';

import { UpdateContract } from './update';

const TabContract = ({ clientCareHistoryItem, clientInformationDetail }) => {
  const [contractList, setContractList] = useState([]);
  const [showDetail, setShowDetail] = useState(null);
  const [selected, setSelected] = useState(null);

  const [selectedUpdate, setSelectedUpdate] = useState(null);

  const getInit = async (id) => {
    try {
      const res = await ApiServices.getContractListByClientCareHistory(id);
      if (res?.data) {
        setContractList(res?.data);
      }
    } catch (error) {
      console.log('get data init failed:::', error);
    }
  };

  useEffect(() => {
    if (clientCareHistoryItem?.id) {
      getInit(clientCareHistoryItem?.id);
    }
  }, [clientCareHistoryItem]);

  const initData = async () => {
    getInit(clientCareHistoryItem?.id);
  };

  const handleShowDetail = (rowData) => {
    setShowDetail(rowData);
  };
  const handleShowUpdate = (rowData) => {
    setSelectedUpdate(rowData);
  };
  const onCloseModal = () => {
    setShowDetail(null);
  };
  const onCloseModalCreate = () => {
    setSelected(null);
  };
  const onCloseModalUpdate = () => {
    setSelectedUpdate(null);
  };

  const columns = [
    {
      id: 'contractNumber',
      numeric: true,
      disablePadding: false,
      align: 'center',
      label: 'Mã hợp đồng',
    },
    {
      id: 'effectiveDate',
      numeric: true,
      disablePadding: false,
      label: 'Ngày bắt đầu',
      align: 'center',
      render: (row) => Utils.formatDateFn(row?.effectiveDate),
    },
    {
      id: 'expireDate',
      numeric: true,
      disablePadding: false,
      label: 'Ngày kết thúc',
      align: 'center',
      render: (row) => Utils.formatDateFn(row?.expireDate),
    },
    {
      id: 'createdOn',
      numeric: true,
      disablePadding: false,
      label: 'Ngày tạo',
      align: 'center',
      render: (row) => Utils.formatDateFn(row?.createdOn),
    },
    {
      id: 'note',
      numeric: true,
      disablePadding: false,
      label: 'Ghi chú',
      align: 'center',
    },
    {
      id: 'actions',
      numeric: false,
      disablePadding: false,
      label: '#',
      width: '10px',
      fixed: 'right',
      align: 'center',
      render: (row) => (
        <Box>
          <IconButton onClick={() => handleShowDetail(row)}>
            <VisibilityIcon color="primary" />
          </IconButton>
          <IconButton onClick={() => handleShowUpdate(row)}>
            <BorderColor color="secondary" />
          </IconButton>
        </Box>
      ),
    },
  ];

  const renderHeader = () => (
    <>
      <ContainerHeader>
        {/* <Typography variant="h6" component="h6" sx={{ m: '10px' }}>
          Hợp đồng
        </Typography> */}
      </ContainerHeader>

      <BtnCreateContract
        variant="contained"
        startIcon={<BsPlusCircle />}
        onClick={() => setSelected({ isNew: true })}
      >
        Thêm mới
      </BtnCreateContract>
    </>
  );

  return (
    <Box sx={{ width: '100%' }}>
      <Table rows={contractList} headCells={columns} renderHeader={renderHeader} />
      {selected?.isNew ? (
        <ModalFormDetail
          open={selected}
          onCloseModal={onCloseModalCreate}
          title="Thêm mới"
          maxWidth="md"
        >
          <CreateForm
            initData={initData}
            onCloseModal={onCloseModalCreate}
            clientCareHistoryItem={clientCareHistoryItem}
            clientInformationDetail={clientInformationDetail}
          />
        </ModalFormDetail>
      ) : (
        <ModalFormDetail
          maxWidth="xl"
          open={!!showDetail}
          onCloseModal={onCloseModal}
          title="Thông tin chi tiết hợp đồng"
        >
          <DetailContract dataSelect={showDetail} />
        </ModalFormDetail>
      )}

      <ModalFormDetail
        maxWidth="xl"
        open={selectedUpdate}
        onCloseModal={onCloseModalUpdate}
        title="Cập nhật hợp đồng"
      >
        <UpdateContract
          clientCareHistoryItem={clientCareHistoryItem}
          clientInformationDetail={clientInformationDetail}
          initData={initData}
          onCloseModal={onCloseModalUpdate}
          selected={selectedUpdate}
        />
      </ModalFormDetail>
    </Box>
  );
};

export { TabContract };
